<template>
  <div>
    <nav-breadcrumb :menu="[{label: '收款对账'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import PayPledgeFinancingComponent from '../../components/PayFinancingComponent'
  import xhr from '../../../utils/xhr'
  import DataTable from '../../../components/DataTable'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'FinancingCashJournalRepayList',
    data() {
      return {
        page: 1,
        pageSize: 10,
        listData: {},
        listColumns: [
          {
            name: '交易时间',
            field: 'cj__postingDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD hh:mm')
            }
          },
          {
            name: '流水号',
            field: 'cj__reference'
          },
          // {
          //   name: '类型',
          //   field: ''
          // },
          {
            name: '客户姓名',
            field: 'i__contactPerson'
          },
          {
            name: '手机号',
            field: 'i__contactTelNo'
          },
          // {
          //   name: '支付方式',
          //   field: ''
          // },
          {
            name: '金额(元)',
            field: 'cj__postingAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '还款账户',
            field: 'cj__outboundAccountDesc',
          },
          {
            name: '收款账户',
            field: 'cj__inboundAccountDesc',
          },
          {
            name: '备注',
            field: 'cj__remarks',
          }
        ],
        payTransactionId: '',
        dialogVisible: false,
        payAccountList: [],
        loanAccountList: [],
        filters: {
          form: {
            fi__transactionNo: '',
            u__customerName: '',
            ct__debtorName: '',
            fi__transactionDate: [],
            ct__productName: ''
          },
          columns: [
            {
              label: '交易时间',
              component: 'date-range-picker',
              field: 'cj__postingDate'
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'i__contactPerson'
            },
            {
              label: '手机号',
              component: 'el-input',
              field: 'i__contactTelNo'
            },
            {
              label: '收款账户',
              component: 'el-select',
              field: 'i__contactTelNo',
              options: [],
            },
            {
              label: '流水号',
              component: 'el-input',
              field: 'cj__reference'
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerCashJournalRepayList()
          }
        },
        actions: [
          {
            label: '导出',
            class: 'el-icon-download el-button--primary',
            clickHandler:()=>{
              let routeData = this.$router.resolve({
                path: '/ix/financing/CashJournal.List?format=xlsx',
                query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ]
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.cj.referenceType': 'Repay',
            'xlist.search.cj.referenceType.op': 'eq',
            'xlist.sort.dataField': 'cj.postingDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerCashJournalRepayList()
      }
    },
    mounted() {
      this.getCustomerCashJournalRepayList()
    },
    components: {
      DataTable,
      PayPledgeFinancingComponent
    },
    methods: {
      getCustomerCashJournalRepayList: function () {
        xhr.getCustomerCashJournalList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.listData = res.data
            }catch(e){

            }
          })

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinancingCashJournalRepayList.vue